import React, { Component } from "react";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Panel } from "primereact/panel";
import Server from "./../Server.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment-jalaali";
import DatePicker from "react-datepicker2";
import { connect } from "react-redux";
import { Loader } from "rsuite";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

class Del_Record extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.toast = React.createRef();

    this.state = {
      layout: "list",
      Date: moment(),
      chequeDate: moment(),
      dashData:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.data
          ? this.props.location.state.data
          : [],
      dashList:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.list
          ? this.props.location.state.list
          : [],
      NewFactors:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.NewFactors
          ? this.props.location.state.NewFactors
          : null,
      NewUsers:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.NewUsers
          ? this.props.location.state.NewUsers
          : null,
    };
  }

  getSettings() {
    let that = this;
    that.setState({
      loading: 1,
    });
    that.Server.send(
      "AdminApi/getSettings",
      {},
      function (response) {
        that.setState({
          loading: 0,
        });
        if (response.data.result) {
          that.setState({
            CreditSupport: response.data.result[0].CreditSupport,
            Raymand: response.data.result[0].Raymand,
          });
        }
      },
      function (error) {
        that.setState({
          loading: 0,
        });
      }
    );
  }
  searchResid() {
    let that = this;
    if(!this.state.resid){
      this.toast.current.show({
        severity: "warn",
        summary: "اطلاعات نادرست",
        detail: (
          <div>
            <span>رسید تراکنش را وارد کنید</span>
          </div>
        ),
        life: 5000,
      });
      return;
    }
    that.setState({
      loading: 1,
    });
    that.Server.send(
      "AdminApi/searchResid",
      { resCode: this.state.resid },
      function (response) {
        that.setState({
          loading: 0,
        });
        if (response.data.result[0]) {
          const record = response.data.result;
          record[0].Amount = record[0].Amount.toString()?.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ","
          );
          record[0].shopName = record[0].Seller[0]
            ? record[0].Seller[0].name
            : "-";
          record[0].name = record[0].userData[0]
            ? record[0].userData[0].name || ""
            : "صندوق";
          record[0].Del = (
            <i
              className="fa fa-times"
              style={{ cursor: "pointer" }}
              aria-hidden="true"
              onClick={(event) => {
                that.deleteResid(record[0]._id);
              }}
            ></i>
          );

          that.setState({
            Grid: record,
          });
        } else {
          that.setState({
            Grid: [],
          });
        }
      },
      function (error) {
        that.setState({
          loading: 0,
        });
      }
    );
  }
  EditRecord= ()=>{
    const param={
      desc: this.state.desc,
      Date: this.state.Date.local("fa").format("jYYYY/jM/jD"),
      DateMiladi: this.state.Date.format("YYYY/M/D"),
      Time: this.state.Time,
      _id: this.state._id,
      resCode: this.state.resid
    }
    if(this.state.chequeNumber){
      param["chequeNumber"] = this.state.chequeNumber;
      param["chequeDate"] = this.state.chequeDate;
      param["chequeDate_c"] = Date.parse(this.state.chequeDate);
    }
    let SCallBack = (response) => {
      if (response.data.error) {
        if (response.data.error_desc)
          this.toast.current.show({
            severity: "error",
            summary: "خطا در ویرایش تراکنش",
            detail: (
              <div>
                <span> {response.data.error_desc}</span>
              </div>
            ),
            life: 8000,
          });
        else
        this.toast.current.show({
            severity: "error",
            summary: "خطا در ویرایش تراکنش",
            detail: (
              <div>
                <span>ویرایش تراکنش به درستی انجام نشد</span>
              </div>
            ),
            life: 8000,
          });
      } else {
        this.toast.current.show({
          severity: "success",
          summary: "عملیات موفق",
          detail: <div>تراکنش با موفقیت ویرایش شد</div>,
          life: 8000,
        });
        this.setState({
          Grid: [],
          visibleDialog: false
        },()=>{
          this.searchResid();
        });
      }
    };
    let ECallBack = (error) => {
      this.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: (
          <div>
            <span>ویرایش تراکنش به درستی انجام نشد</span>
          </div>
        ),
        life: 8000,
      });
    };
    this.Server.send(
      "AdminApi/EditResid",
      param,
      SCallBack,
      ECallBack
    );
  }
  deleteResid(_id) {
    let that = this;
    confirmAlert({
      title: <span className="yekan">حذف رکورد</span>,
      message: <span className="yekan"> آیا از حذف مطمئنید </span>,
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let param = {
              token: localStorage.getItem("api_token"),
              _id: _id,
              userOfSite: this.state.userOfSite,
            };
            let SCallBack = function (response) {
              if (response.data.error) {
                if (response.data.error_desc)
                  that.toast.current.show({
                    severity: "error",
                    summary: "خطا در حذف تراکنش",
                    detail: (
                      <div>
                        <span> {response.data.error_desc}</span>
                      </div>
                    ),
                    life: 8000,
                  });
                else
                  that.toast.current.show({
                    severity: "error",
                    summary: "خطا در حذف تراکنش",
                    detail: (
                      <div>
                        <span>حذف تراکنش به درستی انجام نشد</span>
                      </div>
                    ),
                    life: 8000,
                  });
              } else {
                that.toast.current.show({
                  severity: "success",
                  summary: "عملیات موفق",
                  detail: <div>تراکنش با موفقیت خذف شد</div>,
                  life: 8000,
                });
                that.setState({
                  Grid: [],
                });
              }
            };
            let ECallBack = function (error) {
              that.toast.current.show({
                severity: "error",
                summary: "خطای سرور",
                detail: (
                  <div>
                    <span>حذف تراکنش به درستی انجام نشد</span>
                  </div>
                ),
                life: 8000,
              });
            };
            this.Server.send(
              "AdminApi/deleteResid",
              param,
              SCallBack,
              ECallBack
            );
          },
        },
        {
          label: <span className="yekan">خیر </span>,
        },
      ],
    });
  }

  componentDidMount() {
    let that = this;
    this.Server.send(
      "MainApi/checktoken",
      {
        token: localStorage.getItem("api_token"),
      },
      function (response) {
        that.setState({
          ShopId: response.data.authData.shopId,
          userOfSite: response.data.authData.username,
          userId: response.data.authData.userId,
        });
        that.getSettings();
      },
      function (error) {
        console.log(error);
        that.getSettings();
      }
    );

  }

  rowClass(data) {
    if (data.credit)
      data.credit = data.credit
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return {
      "row-highlight1": 0,
    };
  }
  
  updateTemp() {
    let that = this;
    that.Server.send("MainApi/updateUserIdInCreditPayment", {}, function (response) {
    }, function (error) {
    })
  }

  updateDatesTemp() {
    let that = this;
    that.Server.send("MainApi/updateDateInCreditPayment", {}, function (response) {
    }, function (error) {
    })
  }

  selectedUserChange(value) {
    this.setState({
      visibleDialog: true,
      Date: moment(value.Date, "jYYYY/jM/jD"),
      Time: value.Time,
      desc: value.desc,
      _id: value._id,
      chequeDate: value.cheque[0] ? moment(value.cheque[0].date) : null,
      chequeNumber: value.cheque[0] ? value.cheque[0].number : null,

    });
  }
  render() {
    const footer = (
      <div>
        <button
          className="btn btn-primary irsans"
          onClick={() => this.EditRecord()}
          style={{ width: "200px", marginTop: "5px", marginBottom: "5px" }}
        >
          {" "}
          اعمال{" "}
        </button>
      </div>
    );
    return (
      <div style={{ direction: "rtl" }}>
        {this.state.loading == 1 && (
          <div
            style={{
              position: "fixed",
              zIndex: 2000,
              top: 10,
              left: 15,
              backgroundColor: "#e89f31",
              padding: "2px 20px",
            }}
          >
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        )}
        <Toast
          ref={this.toast}
          position="top-left"
          style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
        />

        <div className="row justify-content-center mt-2">
          <div className="col-lg-12">
            <Panel
              header="ویرایش / حذف تراکنش"
              style={{
                textAlign: "right",
                marginBottom: 50,
                fontFamily: "yekan",
              }}
            >
              <div className="row">
                <div className="col-lg-4 col-12">
                  <div className="group">
                    <input
                      className="form-control irsans"
                      autoComplete="off"
                      type="text"
                      value={this.state.resid}
                      name="resid"
                      onChange={(event) => {
                        this.setState({ resid: event.target.value });
                      }}
                      required="true"
                    />
                    <label>رسید تراکنش</label>
                  </div>
                </div>
                <div className="col-lg-4 col-12">
                  <div className="group">
                    <button
                      className="btn btn-primary irsans"
                      disabled={this.state.loading}
                      onClick={() => {
                        this.setState({
                          loading: 1,
                        });
                        this.searchResid();
                      }}
                      style={{ width: "200px" }}
                    >
                      {" "}
                      جستجو{" "}
                    </button>
                  </div>
                </div>
                <div className="col-lg-4 col-12">
                  <div className="group">
                    <button
                      className="btn btn-info irsans"
                      disabled={true}
                      onClick={() => {
                        this.updateTemp();
                      }}
                      style={{ width: "200px" }}
                    >
                      {" "}
                      به روزرسانی تراکنش ها{" "}
                    </button>
                  </div>
                </div>
                <div className="col-lg-4 col-12">
                  <div className="group">
                    <button
                      className="btn btn-info irsans"
                      disabled={true}
                      onClick={() => {
                        this.updateDatesTemp();
                      }}
                      style={{ width: "200px" }}
                    >
                      {" "}
                      به روزرسانی تاریخ ها{" "}
                    </button>
                  </div>
                </div>
                <div
                  className="col-12"
                  style={{
                    background: "#fff",
                    textAlign: "right",
                    marginTop: 20,
                  }}
                >
                  <DataTable
                    rowClassName={this.rowClass}
                    rows={15}
                    paginator={true}
                    responsive
                    ref={(el) => (this.dt = el)}
                    value={this.state.Grid}
                    selectionMode="single"
                    selection={this.state.selectedUser}
                    onSelectionChange={(e) => this.selectedUserChange(e.value)}
                  >
                    <Column
                      field="username"
                      header="نام کاربری"
                      className="irsans"
                      style={{ textAlign: "right" }}
                    />
                    <Column
                      field="name"
                      header="نام"
                      className="irsans"
                      style={{ textAlign: "right" }}
                    />
                    <Column
                      field="shopName"
                      header="فروشگاه"
                      className="irsans"
                      style={{ textAlign: "right" }}
                    />
                    <Column
                      field="Amount"
                      header="مبلغ"
                      className="irsans"
                      style={{ textAlign: "right" }}
                    />
                    <Column
                      field="Date"
                      header="تاریخ"
                      className="irsans"
                      style={{ textAlign: "right" }}
                    />
                    <Column
                      field="Time"
                      header="زمان"
                      className="irsans"
                      style={{ textAlign: "right" }}
                    />
                    <Column
                      field="resCode"
                      header="رسید"
                      className="irsans"
                      style={{ textAlign: "right" }}
                    />
                    <Column
                      field="Del"
                      header="حذف"
                      className="irsans"
                      style={{ textAlign: "right" }}
                    />
                  </DataTable>
                </div>
              </div>
            </Panel>
          </div>
        </div>

        <Dialog
          header="تغییر سطح دسترسی"
          visible={this.state.visibleDialog}
          style={{ width: "50vw" }}
          footer={footer}
          minY={70}
          maxY={400}
          onHide={() => {
            this.setState({
              visibleDialog: false,
            });
          }}
          maximizable={false}
        >
          <form
            style={{
              maxWidth: 800,
              maxHeight: 450,
              marginBottom: 10,
              maxWidth: 1000,
            }}
          >
            <div className="row">
              <div className="col-lg-6 col-12">
                <div className="group">
                <label style={{top:-20,fontSize:14}}>تاریخ تراکنش</label>

                <DatePicker
                  onChange={(value) => this.setState({ Date: value })}
                  value={this.state.Date}
                  isGregorian={false}
                  timePicker={false}
                  placeholder="تاریخ"
                  persianDigits={false}
                />
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.Time}
                    name="Time"
                    onChange={(event) =>
                      this.setState({ Time: event.target.value })
                    }
                  />
                  <label>زمان</label>
                </div>
              </div>
              <div className="col-lg-12 col-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.desc}
                    onChange={(event) =>
                      this.setState({ desc: event.target.value })
                    }
                    name="desc"
                  />
                  <label>توضیح</label>
                </div>
              </div>
              {this.state.chequeNumber &&
                <div className="col-lg-12 col-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.chequeNumber}
                    onChange={(event) =>
                      this.setState({ chequeNumber: event.target.value })
                    }
                    name="desc"
                  />
                  <label>شماره چک</label>
                </div>
              </div>
              }
              {this.state.chequeDate &&
              <div className="col-lg-12 col-12">
                <div className="group">
                <label style={{top:-20,fontSize:14}}>روز چک</label>

                    <DatePicker
                        onChange={(value) => this.setState({ chequeDate: value })}
                        value={this.state.chequeDate}
                        isGregorian={false}
                        timePicker={false}
                        placeholder="تاریخ چک"
                        persianDigits={false}
                    />
                </div>
              </div>
              }
            </div>
          </form>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(Del_Record);
